//pruebas firebas config

// export const environment = {
//   production: true,
//   firebase: {
//     apiKey: "AIzaSyBxBOWO5I5FTgplvVpEbdL2iYOPtxk8uvg",
//     authDomain: "evans-pruebas.firebaseapp.com",
//     projectId: "evans-pruebas",
//     storageBucket: "evans-pruebas.appspot.com",
//     messagingSenderId: "743954173420",
//     appId: "1:743954173420:web:397d488597cda35e2304c9",
//     measurementId: "G-EK07XS8C2H",
//   },
//   collectionVentas: "ventas",
//   ecommerce: true, //cambia la forma de enrutamiento true: enruta inicialmente a articulos, false: enruta a Intro
//   urlApiSunat: "http://localhost:8000/", //URL de la api para enviar las consultas a SUNAT  en php
//   // urlApiRuc: "http://localhost:3000/", //URL de la api que scrapea la pagina de ruc SUNAT en node.js
//   // urlApiRuc: "http://34.139.28.233:8080/",
//   urlApiRuc: "https://ilrons.cyou:8999/", // ../sunatRucEncript en Authorization va la data a consultar encriptado de
//   //URL de la api que scrapea la pagina de ruc SUNAT en node.js
//   igv: 0.18,
//   cloudMessageAuth:
//     "key=AAAAj0hn6DI:APA91bGsjPDsyiypwyRYlrdQropg9RQYbfSD4sv8DqUe2e30pfQ4T-QqOFmnKr98WjC4FPJg65gSq_jSuAq89r45PE-ehPl0bzMvaBokQW2Pt1mM3WRTrx8vaHNKKzAwV1h3jwJe6qkY",

//   servidor: "prueba",
//   // servidor: "produccion",
// };

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//produccion firebase config

export const environment = {
  production: false,

  firebase: {
    apiKey: "AIzaSyDh8ZSvunLi49jou8xOol5BgNZLD493LVY",
    authDomain: "evans-pedidos.firebaseapp.com",
    projectId: "evans-pedidos",
    storageBucket: "evans-pedidos.appspot.com",
    messagingSenderId: "236804116049",
    appId: "1:236804116049:web:e69e60b2b479ace477b270",
    measurementId: "G-9SWQ2SYH8C",
  },
  collectionVentas: "ventas",
  ecommerce: true, //cambia la forma de enrutamiento true: enruta inicialmente a articulos, false: enruta a Intro

  urlApiSunat: "http://localhost:8000/", //URL de la api para enviar las consultas a SUNAT  en php
  urlApiRuc: "http://localhost:8999/", //URL de la api que scrapea la pagina de ruc SUNAT en node.js
  //   urlApiRuc: "https://ilrons.cyou:8999/", // esta la url es una api instaladao en google cloud ../sunatRucEncript en Authorization va la data a consultar encriptado de
  // urlApiRuc: "http://34.139.28.233:8080/",
  igv: 0.18,
  cloudMessageAuth:
    "key=AAAAj0hn6DI:APA91bGsjPDsyiypwyRYlrdQropg9RQYbfSD4sv8DqUe2e30pfQ4T-QqOFmnKr98WjC4FPJg65gSq_jSuAq89r45PE-ehPl0bzMvaBokQW2Pt1mM3WRTrx8vaHNKKzAwV1h3jwJe6qkY",
  servidor: "produccion",
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
